// extracted by mini-css-extract-plugin
module.exports = {"transportInformation":"transportInformationBox_transportInformation__1iy8K","numberMoved":"transportInformationBox_numberMoved__1UD8t","bold":"transportInformationBox_bold__2IAe_"};